import React, { createContext, useContext, useState, useRef } from 'react';

const StartDateContext = createContext();

// Funktion zur Berechnung des aktuellen Montags
const getCurrentMonday = () => {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 = Sonntag, 1 = Montag, ..., 6 = Samstag
  const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Bei Sonntag: -6, sonst: 1 - dayOfWeek
  
  const monday = new Date(today);
  monday.setDate(today.getDate() + mondayOffset);
  monday.setHours(0, 0, 0, 0); // Setze Zeit auf 00:00:00
  
  return monday;
};

export function StartDateProvider({ children }) {
  const [startDate, setStartDate] = useState(getCurrentMonday());
  const onStartDateChangeRef = useRef(null);
  
  const handleSetStartDate = (newDate) => {
    setStartDate(newDate);
    // Rufe den registrierten Callback auf, falls vorhanden
    if (onStartDateChangeRef.current) {
      onStartDateChangeRef.current(newDate);
    }
  };
  
  const registerOnStartDateChange = (callback) => {
    onStartDateChangeRef.current = callback;
  };
  
  return (
    <StartDateContext.Provider value={{ 
      startDate, 
      setStartDate: handleSetStartDate,
      registerOnStartDateChange
    }}>
      {children}
    </StartDateContext.Provider>
  );
}

export function useStartDate() {
  return useContext(StartDateContext);
}